module.exports = function() {
  return new Worker(__webpack_public_path__ + "144351c773ea2dc4cf49.worker.js");
};